import React from "react";
import FooterSection from "../../components/pages/home/footer-section";
import NavbarSection from "../../components/pages/home/navbar-section";
import ExternalArrow from "../../components/common/external-arrow";
import PageMeta from "../../components/common/page-meta";
import {
  CvBody,
  CvEntry,
  CvIntro,
  CvLinks,
  CvLayout,
  CvPage,
  CvSection,
  CvTitle,
  CvTitleLabel,
} from "./style";

const googleDocsUrl =
  "https://docs.google.com/document/d/1Q2lkBSXDbRnF8M4leunLfOOso_wIr-PuRMKlWU6yD00/edit?usp=sharing";
const pdfUrl =
  "https://drive.google.com/file/d/1tsVg_3VfcMWkeZCzqB1oKui9-yd_Ze5V/view?usp=sharing";

const Cv = () => (
  <CvPage>
    <PageMeta
      title="Experience & Education — Freddy's"
      description="Freddy Albert Sanjaya's work experience, education, skills, and community work."
    />
    <NavbarSection percentage={0} showLine={false} />
    <CvLayout>
      <CvIntro>
        <CvTitle>Experience &amp; Education</CvTitle>
        <p>
          A fuller record of the places I have worked, what I practiced, and
          where I studied.
        </p>
        <CvLinks>
          <a href={googleDocsUrl} target="_blank" rel="noopener noreferrer">
            Google Docs version <ExternalArrow />
          </a>
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
            PDF version <ExternalArrow />
          </a>
        </CvLinks>
      </CvIntro>
      <CvBody>
        <CvSection>
          <CvTitleLabel>Work experience</CvTitleLabel>
          <CvEntry>
            <header>
              <h2>Business &amp; Design Consultant and Freelance</h2>
              <span>Apr 2024 - now</span>
            </header>
            <p>
              Independent consulting and freelance work across business and
              design challenges.
            </p>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>JayJay School — Design Mentor</h2>
              <span>Apr - Oct 2024</span>
            </header>
            <p>
              Evaluated student work, answered questions with constructive
              feedback, led live course discussions, monitored progress, and
              collaborated with instructors to keep the material aligned with
              industry standards.
            </p>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>Traveloka — Visual UI Designer</h2>
              <span>Jan 2022 - May 2024</span>
            </header>
            <p>
              Developed end-to-end product features from scope and design to
              delivery, including usability testing, illustration, iconography,
              and prototype animation. Conducted research and visual
              exploration, acted as Design PIC, and contributed to Traveloka
              Academy and Design Thinking workshops.
            </p>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>Blibli — Associate UX Designer</h2>
              <span>Aug 2019 - Jan 2022</span>
            </header>
            <p>
              Collaborated across checkout, promotions, engagement, and seller
              pricing. Developed use cases and flows for checkout revamp,
              shipping coupon hygiene, contextual vouchers, and maintained
              cross-platform promotion design documentation.
            </p>
          </CvEntry>
        </CvSection>

        <CvSection>
          <CvTitleLabel>Education</CvTitleLabel>
          <CvEntry>
            <header>
              <h2>Institut Bisnis dan Informatika Kwik Kian Gie</h2>
              <span>Mid 2024 - Mid 2028</span>
            </header>
            <p>
              Currently pursuing a second degree, bridging a design background
              with the business challenges navigated today.
            </p>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>BINUS University — Visual Communication Design</h2>
              <span>Mid 2015 - Mid 2019</span>
            </header>
            <p>
              Recognized for an outstanding final project and served as Human
              Resources Manager in Bina Nusantara Computer Club.
            </p>
          </CvEntry>
        </CvSection>

        <CvSection>
          <CvTitleLabel>Skills &amp; tools</CvTitleLabel>
          <p>
            User experience · User interface · Project management · Strategic
            planning · Feasibility studies · Research · Photography
          </p>
          <p>
            Figma · Sketch · Zeplin · Confluence · JIRA · Adobe Creative Suite ·
            Microsoft Office · Academy Ocean LMS
          </p>
        </CvSection>

        <CvSection>
          <CvTitleLabel>Community &amp; volunteer experience</CvTitleLabel>
          <CvEntry>
            <header>
              <h2>Bangkit Academy — Advisor</h2>
              <span>From May 2023</span>
            </header>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>ADPList — Lead City Ambassador, Jakarta</h2>
              <span>Jan 2022 - May 2024</span>
            </header>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>HandtoHand — Growth Manager</h2>
              <span>Feb – Aug 2022</span>
            </header>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>HandtoHand — Lead of Public Relations</h2>
              <span>Sep 2021 – Jan 2022</span>
            </header>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>Blibli Product Series — Guest &amp; Internal Relations</h2>
              <span>Dec 2020 – Jan 2022</span>
            </header>
          </CvEntry>
          <CvEntry>
            <header>
              <h2>Blibli Design — Social Media Committee</h2>
              <span>May 2020 - Jan 2022</span>
            </header>
          </CvEntry>
        </CvSection>
      </CvBody>
    </CvLayout>
    <FooterSection />
  </CvPage>
);

export default Cv;
